import React from "react";
import ContentToolTip from "../../ContentTooltip";

export default function referenceTooltipProcessor({ referenceData }) {
  const processReferenceTooltip = (
    node,
    children,
    processContentPage,
    processDefaultNode,
    ancillaryData,
    referenceSectionId,
    hasSuperscript,
    isMobileDevice,
    isTabletDevice
  ) => {
    const triggerText = node.attribs["data-value"];
    const referenceId = node.attribs["data-reference-id"];
    const content =
      referenceData?.[referenceId] ||
      ancillaryData?.find((element) => element.type === "ReferenceLinks")
        ?.referenceLinks?.[referenceId];

    if (!content) {
      // We were given a referenceId that doesn't exist, let's log it
      window?.DD_RUM?.addError(
        new Error(
          `Reference Tooltip was given a referenceId that does not exist, referenceId: ${referenceId}`
        ),
        {
          scope: "platform-content",
          team: "cd.mergeconflict",
        }
      );

      return processDefaultNode(node, children);
    }

    if (hasSuperscript) {
      return (
        <ContentToolTip
          triggerText={triggerText}
          processContentPage={processContentPage}
          content={content}
          referenceId={referenceId || referenceSectionId}
          isMobileDevice={isMobileDevice}
          isTabletDevice={isTabletDevice}
        />
      );
    } else {
      return (
        <sup>
          <ContentToolTip
            triggerText={triggerText}
            processContentPage={processContentPage}
            content={content}
            referenceId={referenceId || referenceSectionId}
            isMobileDevice={isMobileDevice}
            isTabletDevice={isTabletDevice}
          />
        </sup>
      );
    }
  };

  return { processReferenceTooltip };
}
